import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, XCircle } from 'lucide-react';
export function AudienceSection() {
  const isFor = ['Hombres y mujeres de 20 a 50 años.', 'Personas con ingresos variables o sin empleo estable.', 'Quienes ya han intentado otros métodos y no han logrado ingresos constantes.', 'Personas que quieren un método claro, práctico y flexible.', 'Freelancers que desean complementar sus servicios actuales con productos digitales.'];
  const isNotFor = ['Quienes buscan dinero rápido sin esfuerzo.', 'Personas que no están dispuestas a dedicar unas horas a la semana.', 'Aquellos que quieren un negocio físico tradicional con mucho inventario.', 'Personas que buscan resultados milagrosos.'];
  return <section className="py-24 px-6 lg:px-8 bg-white text-slate-900" data-id="element-1">
      <div className="max-w-6xl mx-auto" data-id="element-2">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-3">
          <h2 className="font-heading text-3xl md:text-4xl font-bold" data-id="element-4">
            ¿Para quién es esto?
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-5">
          {/* Who this is for */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-green-50/50 border border-green-100 rounded-3xl p-8 lg:p-10" data-id="element-6">
            <h3 className="font-heading text-2xl font-bold text-green-800 mb-8 flex items-center gap-3" data-id="element-7">
              <CheckCircle2 className="w-8 h-8 text-green-500" data-id="element-8" />
              ESTO ES PARA TI SI:
            </h3>
            <ul className="space-y-5" data-id="element-9">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-10">
                  <CheckCircle2 className="w-6 h-6 text-green-500 shrink-0 mt-0.5" data-id="element-11" />
                  <span className="text-slate-700 text-lg" data-id="element-12">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is not for */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="bg-red-50/50 border border-red-100 rounded-3xl p-8 lg:p-10" data-id="element-13">
            <h3 className="font-heading text-2xl font-bold text-red-800 mb-8 flex items-center gap-3" data-id="element-14">
              <XCircle className="w-8 h-8 text-red-500" data-id="element-15" />
              ESTO NO ES PARA TI SI:
            </h3>
            <ul className="space-y-5" data-id="element-16">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-17">
                  <XCircle className="w-6 h-6 text-red-400 shrink-0 mt-0.5" data-id="element-18" />
                  <span className="text-slate-700 text-lg" data-id="element-19">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}